<template>
  <span>{{ phone_string }}</span>
</template>

<script>
export default {
  name: "PhoneFormatter",
    props: ['phone'],
    computed: {
      phone_string() {
          return this.phone ? this.phone.replace(/\+?1(\d{3})(\d{3})(\d{4})/, '($1) $2-$3') : '';
      }
    }
}
</script>

<style scoped>

</style>
